import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  id?: string;
};

/**
 * Password field with a show/hide toggle. Keeps the lock-icon layout the auth
 * screens already use, so it drops in place of the hand-rolled inputs.
 */
export default function PasswordInput({ value, onChange, autoComplete = "current-password", id }: Props) {
  const { t } = useTranslation("auth");
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400">
        <i className="ri-lock-line" />
      </div>
      <input
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        className="w-full pl-10 pr-11 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-ocean focus:ring-1 focus:ring-ocean"
      />
      {/* type="button" matters: these sit inside forms that submit on Enter. */}
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? t("auth.hidePassword") : t("auth.showPassword")}
        aria-pressed={visible}
        className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-charcoal transition-colors"
      >
        <i className={visible ? "ri-eye-off-line" : "ri-eye-line"} />
      </button>
    </div>
  );
}
